import { React, useState, useMemo, useEffect } from "react";
import { IMAGES_BASE_URL } from "../../../api/config";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useTranslateKey } from "../../../components/translation/useTranslateKey";
import { useContext } from "react";
import { LangContext } from "../../../components/translation/langugeContext";

function TrustedDevelopers({ developers }) {
  const t = useTranslateKey();
  const { lang } = useContext(LangContext);

  const [isMobile, setIsMobile] = useState(false);
  const [selectedDeveloper, setSelectedDeveloper] = useState({
    id: 18,
    name: "DAMAC",
    name_ar: "داماك",
    slug: "damac",
    logo: "/media/developers/logos/damac.png",
    description:
      "A leading real estate developer in Egypt specializing in upscale residential and commercial properties",
    description_ar:
      "شركة رائدة في مجال تطوير العقارات في مصر متخصصة في العقارات السكنية والتجارية الراقية",
    founded_year: 1982,
    website: "https://www.damacgroup.com/",
    projects_count: 42,
    units_completed: 10000,
    years_experience: 43,
    facebook: null,
    twitter: null,
    instagram: null,
    linkedin: null,
  });

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 10000,
    pauseOnHover: true,
     rtl: lang === "ar",
  };
  useEffect(() => {
    const handleResize = () => {
      const isMobile = window.innerWidth < 768;
      setIsMobile(isMobile);
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleDeveloperClick = (developer) => {
    if (isMobile) {
      const section = document.getElementById("developer-section");
      if (!section) return;

      const offset = 0; // Adjust this based on any sticky headers
      const sectionTop =
        section.getBoundingClientRect().top + window.scrollY + offset;

      window.scrollTo({
        top: sectionTop,
        behavior: "smooth",
      });

      // Highlight or update UI
    }
    setSelectedDeveloper(developer);
  };
  // Function to chunk the array into smaller arrays of a specified size
  const chunkArray = (arr, size) =>
    arr.reduce(
      (acc, _, i) => (i % size === 0 ? [...acc, arr.slice(i, i + size)] : acc),
      []
    );
  const developerChunks = useMemo(() => {
    if (!developers || developers.length === 0) return [];
    return chunkArray(developers, 6);
  }, [developers]);

  return (
    <>
      {/* Developer Logos Section */}
      <div className="container  transform mx-auto px-4 mb-8  relative cursor-pointer  transition-transform duration-500 group hover:scale-110">
        <div className="developer-logos-container">
          <div className="developer-flex-container">
            {/* Left Column - Expanded View */}
            <div id="developer-section" className="expanded-developer">
              {selectedDeveloper && (
                <div className="developer-details bg-[#11132F] p-6 rounded-lg shadow-lg">
                  {/* Centered Image */}
                  <div className="flex justify-center mb-4">
                    {" "}
                    {/* ← Flex container for centering */}
                    <img
                      width={200}
                      height={200}
                      src={`${IMAGES_BASE_URL}${selectedDeveloper.logo}`}
                      className=" object-contain"
                    />
                  </div>
                  <h3 className="text-3xl font-bold text-white mb-4">
                    {lang === "ar" ? selectedDeveloper.name_ar : selectedDeveloper.name}
                    
                  </h3>
                  <p className="text-gray-300 mb-6">
                     {lang === "ar" ? selectedDeveloper.description_ar : selectedDeveloper.description}
                  </p>
                  <div className="developer-stats flex justify-between mt-6">
                    <div className="stat-item text-center">
                      <div className="stat-label text-gray-400 text-sm mt-1 capitalize">
                        {t("projects")}
                      </div>
                      <div className="stat-value text-white font-bold text-xl">
                        +{selectedDeveloper.projects_count}
                      </div>
                    </div>
                    <div className="stat-item text-center">
                      <div className="stat-label text-gray-400 text-sm mt-1 capitalize">
                       {t("units")}
                      </div>
                      <div className="stat-value text-white font-bold text-xl">
                        +{selectedDeveloper.units_completed}
                      </div>
                    </div>
                    <div className="stat-item text-center">
                      <div className="stat-label text-gray-400 text-sm mt-1 capitalize">
                        {t("experience")}
                      </div>
                      <div className="stat-value text-white font-bold text-xl">
                        +{selectedDeveloper.years_experience}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Right Column - Carousel */}
            <div className="carousel-developer" dir={lang === "ar" ? "rtl" : "ltr"}>
              <h2 className="font-bold text-white mb-8 text-center text-3xl">
                {t("trusted_developers")}
              </h2>
              {/* <!-- Slider -> */}
              
              <Slider key={lang} {...settings} >
                {developerChunks.map((group, index) => (
                  <div key={index} className="full-width">
                    <div className="developer-grid">
                      {group.map((dev, i) => (
                        <button
                          key={0}
                          onClick={() => {
                            handleDeveloperClick(dev);
                          }}
                          className="flex-shrink-0 w-32 h-32 hover:bg-gray-700 rounded-lg p-4 transition-colors"
                        >
                          <img
                            src={`${IMAGES_BASE_URL}${dev.logo}`}
                            alt={dev.name}
                            className="w-full h-24 object-contain mb-2"
                          />
                          <h4 className="text-center text-sm font-semibold">
                              {lang === "ar" ? dev.name_ar : dev.name}
                          </h4>
                        </button>
                      ))}
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
          <div className="view-all-btn-container">
            <a
              href="/developers"
              className="view-all-btn inline-block px-6 py-2 rounded-lg"
            >
              {t("view_All_Developers")}
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
export default TrustedDevelopers;
